import get from 'lodash/get';
import { libraryExample } from 'reducers/scriptStepModal/scriptExamples';
import {
  LIBRARY_MODAL_CLOSE,
  LIBRARY_MODAL_ADD_NEW,
  LIBRARY_MODAL_SELECT,
  LIBRARY_MODAL_NAME_CHANGE,
  LIBRARY_MODAL_CODE_CHANGE,
  LIBRARY_MODAL_CLEAN,
  OPEN_LIBRARIES_DIALOG,
  CLOSE_LIBRARIES_DIALOG,
  DELETE_LIBRARY_SUCCESS,
} from 'actions/libraries/modal';

const getInitialAddLibraryState = (
  owner,
  defaultName,
  script = libraryExample,
) => ({
  owner,
  id: undefined,
  name: defaultName,
  script,
  accessType: 'CAN_EDIT',
});

const getInitialModalState = () => ({
  selected: null,
  isOpen: false,
});

export const getInitialState = () => ({
  scriptStepModal: getInitialModalState(),
  librariesDialog: getInitialModalState(),
});

export default function librariesModalReducer(
  state = getInitialState(),
  action,
) {
  const { payload = {} } = action;
  const modalId = get(payload, 'modalId', 'generic');

  switch (action.type) {
    case OPEN_LIBRARIES_DIALOG: {
      return {
        ...state,
        [modalId]: {
          ...state[modalId],
          isOpen: true,
        },
      };
    }
    case CLOSE_LIBRARIES_DIALOG:
      return {
        ...state,
        [modalId]: {
          ...state[modalId],
          isOpen: false,
        },
      };
    case LIBRARY_MODAL_CLOSE: {
      return { ...state, [modalId]: { ...state[modalId], selected: null } };
    }
    case LIBRARY_MODAL_ADD_NEW: {
      return {
        ...state,
        [modalId]: {
          ...state[modalId],
          selected: getInitialAddLibraryState(
            payload.owner,
            payload.defaultName,
            payload.initialScript,
          ),
        },
      };
    }
    case LIBRARY_MODAL_SELECT: {
      return {
        ...state,
        [modalId]: {
          ...state[modalId],
          // Note: we're creating a shallow copy of the library so that
          // the original object does not get impacted if changes happen
          selected: payload.library ? { ...payload.library } : null,
        },
      };
    }
    case LIBRARY_MODAL_NAME_CHANGE: {
      return {
        ...state,
        [modalId]: {
          ...state[modalId],
          selected: {
            ...state[modalId].selected,
            name: payload.name,
          },
        },
      };
    }
    case LIBRARY_MODAL_CODE_CHANGE: {
      return {
        ...state,
        [modalId]: {
          ...state[modalId],
          selected: {
            ...state[modalId].selected,
            script: payload.script,
          },
        },
      };
    }
    case LIBRARY_MODAL_CLEAN: {
      return {
        ...state,
        [modalId]: getInitialModalState(),
      };
    }
    case DELETE_LIBRARY_SUCCESS: {
      // if the deleted library is selected, null the selection
      const selectedLibraryId = get(state[modalId], 'selected.id', null);

      if (selectedLibraryId !== action.payload.id) {
        return state;
      }

      return {
        ...state,
        [modalId]: {
          ...state[modalId],
          selected: null,
        },
      };
    }
    default: {
      return state;
    }
  }
}
